<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import VueEasyLightbox from "vue-easy-lightbox";
import Services_Gallery from "@/assets/json/services-gallery.json";
import "vue3-carousel/dist/carousel.css";

export default {
  data() {
    return {
      Services_Gallery: Services_Gallery,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },
      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 4,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 6,
          snapAlign: "center",
        },
      },
      visible: false,
      index: 0,
    };
  },
  computed: {
    images() {
      return this.Services_Gallery.map((item) => ({
        src: item.Image,
      }));
    },
  },
  methods: {
    openLightbox(index) {
      this.index = index; // Set current index
      this.visible = true; // Show lightbox
    },
    openLightboxGallery() {
      this.index = 0; // Start from the first image
      this.visible = true; // Show lightbox
    },
    handlePrev() {
      // Handle previous image logic (if needed)
    },
    handleNext() {
      // Handle next image logic (if needed)
    },
    slideTo(index) {
      this.index = index; // Change main slider to the thumbnail clicked
    },
  },
  components: {
    Carousel,
    Slide,
    Navigation,
    VueEasyLightbox,
  },
};
</script>

<template>
  <div class="accordion-item mb-4">
    <h2 class="accordion-header">
      <button
        class="accordion-button p-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#gallery"
        aria-expanded="false"
      >
        Gallery
      </button>
    </h2>
    <div id="gallery" class="accordion-collapse collapse show">
      <div class="accordion-body border-0 p-0 pt-3">
        <div class="gallery-slider owl-carousel nav-center">
          <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
            <Slide
              v-for="(item, index) in Services_Gallery"
              :key="item.id"
              @click="openLightbox(index)"
            >
              <img
                :src="require(`@/assets/img/services/${item.Image}`)"
                class="gallery-item"
                alt="img"
              />
            </Slide>
            <template #addons>
              <Navigation />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
  <vue-easy-lightbox
    :visible="visible"
    :index="index"
    :imgs="
      images.map((image) => ({
        src: require(`@/assets/img/services/${image.src}`),
      }))
    "
    @hide="visible = false"
    @on-prev="handlePrev"
    @on-next="handleNext"
  />
</template>
